// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-workflows?path=%2Ftypes%2Fhoneybee%2Fsrc%2Fannotations.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { IAdditionalData, IFactPredictionRequest, IHoneybeeRequest, IHoneybeeServiceRequest, IHoneybeeServiceSuggestion, IHoneybeeSuggestion, IInlineSearchSuggestion, IRankedHoneybeeSuggestion, IUserDataSignal, KVPair } from '../annotations';
import { AnnotationMetaData, ISchemaObject, SchemaObject, SchemaObjectHeader } from '@augloop/types-core';
import { DataProviderType, UserDataRequestType } from '../ows-model';

export class HoneybeeRequest implements IHoneybeeRequest {
    public context: string;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IHoneybeeRequest) {
        SchemaObject.assign(HoneybeeRequest, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_HoneybeeRequest';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: HoneybeeRequest.getTypeName(), B_: HoneybeeRequest.getBaseTypes() };
}

export class HoneybeeServiceRequest implements IHoneybeeServiceRequest {
    public readonly text: string;
    public readonly isInitOp: boolean;
    public readonly requestType: UserDataRequestType;
    public readonly referenceItemId?: string;
    public readonly dataProviderList?: DataProviderType[];
    public readonly customSettings?: KVPair[];
    public readonly requestStartTimeInMs?: number;
    public intentEntities?: string[];
    public context: string;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IHoneybeeServiceRequest) {
        SchemaObject.assign(HoneybeeServiceRequest, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_HoneybeeServiceRequest';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Honeybee_HoneybeeRequest', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: HoneybeeServiceRequest.getTypeName(), B_: HoneybeeServiceRequest.getBaseTypes() };
}

export class UserDataSignal implements IUserDataSignal {
    public readonly text: string;
    public readonly context: string;
    public readonly referenceItemId?: string;
    public readonly dataProviders?: number[];
    public readonly customSettings?: KVPair[];
    public targetObject?: ISchemaObject;
    public timestamp?: number;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IUserDataSignal) {
        SchemaObject.assign(UserDataSignal, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_UserDataSignal';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Signals_Signal'];
    }
    public static readonly H_ = { T_: UserDataSignal.getTypeName(), B_: UserDataSignal.getBaseTypes() };
}

export class FactPredictionRequest implements IFactPredictionRequest {
    public readonly queries: string[];
    public context: string;
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IFactPredictionRequest) {
        SchemaObject.assign(FactPredictionRequest, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_FactPredictionRequest';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Honeybee_HoneybeeRequest', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: FactPredictionRequest.getTypeName(), B_: FactPredictionRequest.getBaseTypes() };
}

export class HoneybeeSuggestion implements IHoneybeeSuggestion {
    public context: string;
    public s?: string;
    public i?: string;
    public l: number;
    public m?: string;
    public x?: number;
    public f?: number;
    public t?: string;
    public r?: number;
    public alts?: string;
    public ad?: IAdditionalData[];
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IHoneybeeSuggestion) {
        SchemaObject.assign(HoneybeeSuggestion, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_HoneybeeSuggestion';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: HoneybeeSuggestion.getTypeName(), B_: HoneybeeSuggestion.getBaseTypes() };
}

export class HoneybeeServiceSuggestion implements IHoneybeeServiceSuggestion {
    public requestType: UserDataRequestType;
    public context: string;
    public s?: string;
    public i?: string;
    public l: number;
    public m?: string;
    public x?: number;
    public f?: number;
    public t?: string;
    public r?: number;
    public alts?: string;
    public ad?: IAdditionalData[];
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IHoneybeeServiceSuggestion) {
        SchemaObject.assign(HoneybeeServiceSuggestion, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_HoneybeeServiceSuggestion';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Honeybee_HoneybeeSuggestion', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: HoneybeeServiceSuggestion.getTypeName(), B_: HoneybeeServiceSuggestion.getBaseTypes() };
}

export class RankedHoneybeeSuggestion implements IRankedHoneybeeSuggestion {
    public sourceName: string;
    public context: string;
    public s?: string;
    public i?: string;
    public l: number;
    public m?: string;
    public x?: number;
    public f?: number;
    public t?: string;
    public r?: number;
    public alts?: string;
    public ad?: IAdditionalData[];
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IRankedHoneybeeSuggestion) {
        SchemaObject.assign(RankedHoneybeeSuggestion, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_RankedHoneybeeSuggestion';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Honeybee_HoneybeeSuggestion', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: RankedHoneybeeSuggestion.getTypeName(), B_: RankedHoneybeeSuggestion.getBaseTypes() };
}

export class InlineSearchSuggestion implements IInlineSearchSuggestion {
    public sourceName: string;
    public requestType: UserDataRequestType;
    public context: string;
    public s?: string;
    public i?: string;
    public l: number;
    public m?: string;
    public x?: number;
    public f?: number;
    public t?: string;
    public r?: number;
    public alts?: string;
    public ad?: IAdditionalData[];
    public id?: string;
    public ownerId?: string;
    public invalidationHash?: string;
    public M_?: AnnotationMetaData;
    public get metadata(): AnnotationMetaData | undefined { return this.M_; }
    public set metadata(value: AnnotationMetaData | undefined) { this.M_ = value; }
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IInlineSearchSuggestion) {
        SchemaObject.assign(InlineSearchSuggestion, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Honeybee_InlineSearchSuggestion';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Honeybee_HoneybeeSuggestion', 'AugLoop_Core_Annotation'];
    }
    public static readonly H_ = { T_: InlineSearchSuggestion.getTypeName(), B_: InlineSearchSuggestion.getBaseTypes() };
}

